/* src/app/forms/gridview/filterview/form-configuration/form-configuration-tab-select/form-configuration-tab-select.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 20px;
  gap: var(--tem-space-3);
}
.content-container {
  width: 100%;
}
.options {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  gap: 10px;
  align-items: flex-end;
}
/*# sourceMappingURL=form-configuration-tab-select.component.css.map */
